import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import MainView from '@/MainView.vue'
import StatusView from '@/StatusView.vue'
import HazardReport from '@/components/hazard/HazardReport.vue'
import SearchView from '@/components/search/SearchView.vue'
import StdizerView from '@/components/stdizer/StdizerView.vue'
import UtilitiesView from '@/components/utils/UtilitiesView.vue'
import ProtocolsTable from '@/components/stdizer/ProtocolsTable'
import ProtocolView from '@/components/stdizer/ProtocolView.vue'
import LibraryTable from '@/components/stdizer/LibraryTable'
import OperationsGroup from '@/components/stdizer/OperationsGroup'
import ToxprintsView from '@/components/toxprints/ToxprintsView'
import AdminView from '@/components/admin/AdminView'
import UsersTable from '@/components/auth/UsersTable'
import AccountView from '@/components/auth/AccountView'
import HazardView from '@/components/hazard/HazardView'
import ReportsTable from '@/components/hazard/ReportsTable'
import ChecksGroup from '@/components/alerts/ChecksGroup'
import AlertsView from '@/components/alerts/AlertsView.vue'
import AlertsLibrary from '@/components/alerts/AlertsLibrary'
import SafetyView from '@/components/safety/SafetyView.vue'
import SafetyReport from '@/components/safety/SafetyReport.vue'
import PubchemReport from '@/components/pubchem/PubchemReport.vue'
import DataSourcesAndAnnotations from '@/components/utils/DataSourcesAndAnnotations.vue'
import PubchemList from '@/components/utils/PubchemList.vue'
import SimilarityMap from '@/components/utils/SimilarityMap.vue'
import SimilarityList from '@/components/utils/SimilarityList.vue'
import AMOS from '@/components/AMOS.vue'
import ReleaseNotes from '@/components/ReleaseNotes.vue'
import MediaView from '@/MediaView.vue'
import CheT from '@/components/CheT.vue'
import CombinedPredict from '@/components/combined-predict/CombinedPredict.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: MainView },

  { path: '/status', component: StatusView, meta: { title: 'Models / API' } },

  { path: '/hazard', component: HazardView, meta: { title: 'Hazard' } },
  { path: '/hazard/report', component: HazardReport, meta: { title: 'Hazard' } },
  { path: '/hazard/report/:chemId', component: HazardReport, meta: { title: 'Hazard' } },
  { path: '/hazard/reports', component: ReportsTable, meta: { title: 'Hazard' } },
  { path: '/hazard/reports/:id', component: HazardReport, meta: { title: 'Hazard' } },

  { path: '/safety', component: SafetyView, meta: { title: 'Safety' } },
  { path: '/safety/report', component: SafetyReport, meta: { title: 'Safety' } },
  { path: '/safety/report/:chemId', component: SafetyReport, meta: { title: 'Safety' } },
  { path: '/safety/reports/:sid', component: PubchemReport, meta: { title: 'Safety' } },
  { path: '/safety/reports/:sid/:section', component: PubchemReport, meta: { title: 'Safety' } },

  { path: '/amosapp', component: AMOS, meta: { title: 'AMOS' } },
  { path: '/chetapp', component: CheT, meta: { title: 'CheT' } },

  { path: '/combined-predict', component: CombinedPredict, meta: { title: 'Combined Predict' } },

  { path: '/search', component: SearchView, meta: { title: 'Search' } },

  { path: '/stdizer', component: StdizerView, meta: { title: 'Standardize' } },
  { path: '/stdizer/protocols', component: ProtocolsTable, meta: { title: 'Standardize' } },
  { path: '/stdizer/protocol', component: ProtocolView, meta: { title: 'Standardize' } },
  { path: '/stdizer/protocols/:id', component: ProtocolView, meta: { title: 'Standardize' } },
  { path: '/stdizer/groups', component: LibraryTable, meta: { title: 'Standardize' } },
  { path: '/stdizer/groups/:id', component: OperationsGroup, meta: { title: 'Standardize' } },

  { path: '/utils', component: UtilitiesView, meta: { title: 'Utilities' } },
  {
    path: '/utils/datasources',
    component: DataSourcesAndAnnotations,
    meta: { title: 'Pubchem Data Sources and Annotations' },
  },
  { path: '/utils/pubchem', component: PubchemList, meta: { title: 'Integrity Check' } },
  { path: '/utils/simmap', component: SimilarityMap, meta: { title: 'Similarity Matrix' } },
  {
    path: '/utils/simlist',
    name: 'simlist',
    component: SimilarityList,
    props: true,
    meta: { title: 'Similarity List' },
  },

  { path: '/alerts', component: AlertsView, meta: { title: 'Alerts' } },
  { path: '/alerts/groups', component: AlertsLibrary, meta: { title: 'Alerts' } },
  { path: '/alerts/groups/:id', component: ChecksGroup, meta: { title: 'Alerts' } },

  { path: '/toxprints', component: ToxprintsView, meta: { title: 'Fingerprints' } },
  { path: '/toxprints/report', component: ToxprintsView, meta: { title: 'Fingerprints' } },
  { path: '/toxprints/global_assays', component: ToxprintsView, meta: { title: 'Fingerprints' } },
  { path: '/toxprints/assays', component: ToxprintsView, meta: { title: 'Fingerprints' } },
  { path: '/toxprints/assays/:name', component: ToxprintsView, meta: { title: 'Fingerprints' } },

  { path: '/admin', component: AdminView, meta: { admin: true, title: 'Admin' } },
  { path: '/users', component: UsersTable, meta: { admin: true, title: 'Users' } },
  { path: '/users/:id', component: AccountView, meta: { authenticated: true, title: 'Users' } },

  { path: '/release_notes', component: ReleaseNotes, meta: { title: 'Release Notes' } },
  { path: '/media', component: MediaView, meta: { title: 'Media' } },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.admin)) {
    if (store.getters.isAdmin) {
      next()
      return
    }
    next('/')
  }
  if (to.matched.some((record) => record.meta.authenticated)) {
    if (store.getters.isAuthenticated) {
      next()
      return
    }
    next('/')
  } else {
    next()
  }
})

export default router
